/** @format */

const SERVICE_HOST = {
  // DEV: 'http://127.0.0.1:4008/',
  // PROD: 'http://127.0.0.1:4008/',
  DEV: 'http://1.14.62.248/:4008/',
  PROD: 'http://1.14.62.248/:4008/',
};

const ideamanServiceUrl =
  process.env.NODE_ENV === 'development' ? SERVICE_HOST.DEV : SERVICE_HOST.PROD;

module.exports = {
  ideamanServiceUrl,
};
